module.exports = __webpack_public_path__ + "img/d6512-none.45e50c35.png";